var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"$box",staticClass:"c-sticky-box",style:(_vm.boxStyle)},[_c('div',{ref:"$content",staticClass:"content",style:(_vm.contentStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }